
import { FontInfo } from "../FontInfo";

export class Jost_100 extends FontInfo
{
  fontName = "Jost";
  weight   = 100;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,262,403,571,580,701,675,223,240,240,592,550,276,210,260,475,550,410,514,551,553,557,536,515,516,536,300,276,640,615,640,542,770,600,495,685,635,510,450,765,647,180,197,454,430,830,725,774,480,771,468,488,431,576,600,950,500,507,535,260,435,260,510,500,353,435,541,488,541,502,278,541,475,190,180,372,180,690,475,556,541,541,290,403,190,475,420,620,380,425,430,281,210,281,575]
    }
  ]
}


export class Jost_200 extends FontInfo
{
  fontName = "Jost";
  weight   = 200;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,273,421,581,580,716,675,241,261,261,592,569,285,210,272,487,565,422,530,550,562,559,548,518,525,548,300,292,640,615,640,546,770,618,513,685,648,522,465,768,667,199,210,487,436,824,740,779,500,777,495,506,441,591,618,962,516,523,538,272,458,272,510,500,359,448,550,485,550,506,280,550,490,211,201,392,195,716,490,553,550,550,306,403,205,490,426,638,392,429,439,290,229,290,575]
    }
  ]
}


export class Jost_300 extends FontInfo
{
  fontName = "Jost";
  weight   = 300;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,285,440,591,580,731,675,260,282,282,592,589,295,210,284,499,580,434,547,548,571,561,560,521,534,560,300,308,640,615,640,551,770,636,533,685,662,534,480,771,688,219,223,521,442,818,755,784,521,782,523,524,451,606,636,974,533,539,541,284,483,284,510,500,366,463,558,482,558,510,283,558,505,232,222,413,210,744,505,550,558,558,322,403,220,505,432,656,404,434,448,299,248,299,575]
    }
  ]
}


export class Jost_400 extends FontInfo
{
  fontName = "Jost";
  weight   = 400;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,300,465,605,580,751,675,285,310,310,592,615,308,210,300,515,600,450,569,546,583,564,576,525,546,576,300,330,640,615,640,557,770,660,558,685,680,550,500,775,715,245,240,565,450,810,775,790,548,790,560,548,465,626,660,990,555,561,545,300,515,300,510,500,375,481,570,478,570,515,286,570,525,260,250,440,230,780,525,546,570,570,343,403,240,525,440,680,420,440,460,311,274,311,575]
    }
  ]
}


export class Jost_500 extends FontInfo
{
  fontName = "Jost";
  weight   = 500;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,318,486,630,597,819,706,294,323,323,592,639,314,215,309,553,625,474,604,576,629,597,614,556,579,614,309,355,640,620,640,585,770,690,601,691,701,571,521,791,744,275,276,619,481,843,783,803,578,820,595,579,504,656,690,1020,608,601,575,325,528,325,510,513,375,504,589,484,589,539,309,586,543,267,259,495,246,796,545,564,589,589,371,424,271,545,475,713,465,473,485,346,306,346,575]
    }
  ]
}


export class Jost_600 extends FontInfo
{
  fontName = "Jost";
  weight   = 600;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,330,501,648,609,867,728,300,331,331,592,656,319,219,315,579,643,491,629,597,662,620,640,579,602,640,315,373,640,623,640,605,770,711,631,696,716,586,536,802,764,296,302,658,504,866,788,811,599,841,620,601,531,677,711,1041,645,629,596,343,536,343,510,521,375,521,602,489,602,555,326,598,555,271,265,534,258,808,559,576,602,602,390,439,294,559,500,736,497,496,503,371,328,371,575]
    }
  ]
}


export class Jost_700 extends FontInfo
{
  fontName = "Jost";
  weight   = 700;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,343,518,667,622,919,752,307,341,341,592,674,324,222,322,608,662,509,656,621,698,645,669,603,627,669,322,393,640,626,640,627,770,735,664,701,733,603,553,814,786,320,330,699,528,891,794,821,623,863,647,625,561,701,735,1065,685,660,620,362,546,362,510,531,375,539,617,494,617,573,344,610,568,276,272,577,270,820,575,589,617,617,411,456,318,575,527,761,532,521,522,398,352,398,575]
    }
  ]
}


export class Jost_800 extends FontInfo
{
  fontName = "Jost";
  weight   = 800;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,356,534,686,634,969,775,313,350,350,592,692,328,226,329,636,681,527,682,643,732,669,697,626,651,697,329,412,640,630,640,647,770,757,695,705,749,619,569,826,808,342,357,739,551,915,799,830,645,885,673,648,590,723,757,1087,724,689,642,381,555,381,510,540,375,556,631,498,631,591,361,622,581,281,278,618,282,832,590,602,631,631,432,472,341,590,553,785,565,545,541,424,376,424,575]
    }
  ]
}


export class Jost_900 extends FontInfo
{
  fontName = "Jost";
  weight   = 900;
  italic   = false;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 300,370,550,705,647,1021,799,320,360,360,592,710,333,230,336,665,700,545,709,666,768,694,726,650,676,726,336,431,640,633,640,669,770,780,728,710,765,635,585,838,830,365,385,781,575,940,805,840,668,908,700,672,620,746,780,1110,765,720,665,400,565,400,510,550,375,574,645,503,645,609,379,635,595,286,285,660,295,845,605,616,645,645,453,488,365,605,580,810,600,570,560,451,400,451,575]
    }
  ]
}


export class Jost_100_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 100;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,254,391,554,563,680,655,216,233,233,575,534,268,204,252,461,534,398,499,535,537,541,520,500,501,520,291,268,621,597,621,526,747,582,480,665,616,495,437,742,628,175,191,441,417,805,675,751,466,748,454,474,418,559,582,922,485,492,519,252,422,252,495,485,343,525,525,474,525,502,270,525,461,184,175,361,175,670,461,540,525,525,281,391,184,461,408,602,369,412,417,273,204,273,558]
    }
  ]
}


export class Jost_200_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 200;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,265,409,564,563,694,655,234,253,253,575,552,277,204,263,472,548,409,515,534,546,543,531,503,510,531,291,283,621,597,621,530,747,599,498,665,629,506,451,745,647,193,203,472,423,799,698,756,485,754,480,491,428,573,599,933,501,507,522,263,445,263,495,485,349,533,533,471,533,501,272,533,475,204,195,380,189,696,475,537,533,533,296,391,198,475,414,619,380,416,426,282,222,282,558]
    }
  ]
}


export class Jost_300_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 300;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,276,427,574,563,709,655,253,274,274,575,572,287,204,275,484,563,421,531,532,554,545,543,505,518,543,291,299,621,597,621,535,747,617,517,665,642,518,466,748,668,213,216,505,429,794,721,761,506,759,507,509,438,588,617,945,517,523,525,275,469,275,495,485,356,542,542,468,542,501,275,542,490,225,216,401,204,722,490,534,542,542,312,391,213,490,419,637,392,421,434,290,241,290,558]
    }
  ]
}


export class Jost_400_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 400;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,291,451,587,563,729,655,277,301,301,575,597,299,204,291,500,582,437,552,530,566,547,559,509,530,559,291,320,621,597,621,541,747,640,542,665,660,534,485,752,694,238,233,548,437,786,752,767,532,767,543,532,451,608,640,961,539,544,529,291,500,291,495,485,364,553,553,464,553,500,278,553,509,252,243,427,223,757,509,530,553,553,333,391,233,509,427,660,408,427,446,302,266,302,558]
    }
  ]
}


export class Jost_500_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 500;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,308,472,611,579,795,685,286,313,313,575,620,305,209,300,536,606,460,586,559,611,579,596,540,562,596,300,345,621,601,621,568,747,669,583,671,681,555,506,767,722,267,268,601,467,818,759,779,561,796,577,562,489,637,669,990,590,583,558,315,512,315,495,497,364,571,571,468,571,523,301,569,526,259,252,480,239,773,529,547,571,571,361,412,263,529,461,692,452,459,470,336,297,336,558]
    }
  ]
}


export class Jost_600_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 600;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,320,487,629,591,841,706,292,322,322,575,636,309,212,306,562,624,476,610,580,643,601,622,561,584,622,306,362,621,604,621,587,747,690,612,675,695,569,521,778,742,288,293,638,489,840,764,788,582,816,601,583,516,658,690,1011,626,610,579,333,521,333,495,506,364,584,584,471,584,539,317,580,538,263,258,518,250,784,542,559,584,584,381,427,285,542,485,714,483,481,488,360,318,360,558]
    }
  ]
}


export class Jost_700_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 700;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,333,503,647,603,892,730,298,331,331,575,654,314,216,313,590,642,494,637,602,677,625,650,585,608,650,313,381,621,608,621,608,747,713,644,680,711,585,537,790,763,310,321,678,512,864,770,797,604,838,628,607,545,680,713,1033,665,640,601,351,530,351,495,515,364,598,598,475,598,557,334,592,551,268,264,559,262,796,557,572,598,598,403,443,308,557,512,738,516,505,506,387,342,387,558]
    }
  ]
}


export class Jost_800_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 800;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,346,518,665,615,940,752,304,340,340,575,671,318,219,319,617,660,511,662,624,710,649,677,607,632,677,319,399,621,611,621,628,747,734,674,684,726,600,552,801,784,332,347,717,535,888,775,806,626,859,653,629,573,702,734,1055,703,669,623,369,539,369,495,525,364,612,612,478,612,573,351,604,564,273,270,599,274,808,572,585,612,612,423,458,331,572,537,762,548,529,524,412,364,412,558]
    }
  ]
}


export class Jost_900_italic extends FontInfo
{
  fontName = "Jost";
  weight   = 900;
  italic   = true;

  widthRanges =  [
    {
      startIndex: 32,
      widths: [ 301,359,534,684,628,991,775,311,349,349,575,689,323,223,326,645,679,529,688,646,745,673,705,631,656,705,326,418,621,614,621,649,747,757,706,689,742,616,568,813,805,354,374,758,558,912,781,815,648,881,679,652,602,724,757,1077,742,699,645,388,548,388,495,534,364,626,626,481,626,591,368,616,577,278,277,640,286,820,587,598,626,626,445,474,354,587,563,786,582,553,543,438,388,438,558]
    }
  ]
}


export class Jost
{
  static readonly fonts = [ new Jost_100(), new Jost_200(), new Jost_300(), new Jost_400(), new Jost_500(), new Jost_600(), new Jost_700(), new Jost_800(), new Jost_900(), new Jost_100_italic(), new Jost_200_italic(), new Jost_300_italic(), new Jost_400_italic(), new Jost_500_italic(), new Jost_600_italic(), new Jost_700_italic(), new Jost_800_italic(), new Jost_900_italic() ];
}

